import React, { useState, useEffect } from 'react';
import { collection, onSnapshot } from 'firebase/firestore';
import { db, auth } from '../../firebase';
import AddCategoryDialog from './AddCategoryDialog';
import './Categories.css';

function Categories() {
  const [incomeCategories, setIncomeCategories] = useState([]);
  const [expenseCategories, setExpenseCategories] = useState([]);
  const [showAddDialog, setShowAddDialog] = useState(false);
  const [editingCategory, setEditingCategory] = useState(null);
  const user = auth.currentUser;

  // Sort function for ledger codes
  const sortByLedger = (categories) => {
    return categories.sort((a, b) => {
      const getLedgerNumber = (ledger) => {
        if (!ledger) return 0;
        const lastFour = ledger.slice(-4);
        return parseInt(lastFour, 10) || 0;
      };
      return getLedgerNumber(a.Ledger) - getLedgerNumber(b.Ledger);
    });
  };

  // Load income categories
  useEffect(() => {
    if (!user) return;
    const q = collection(db, 'users', user.uid, 'income_categories');
    const unsubscribe = onSnapshot(q, (snapshot) => {
      const categoriesData = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      setIncomeCategories(sortByLedger(categoriesData));
    });
    return unsubscribe;
  }, [user]);

  // Load expense categories
  useEffect(() => {
    if (!user) return;
    const q = collection(db, 'users', user.uid, 'expense_categories');
    const unsubscribe = onSnapshot(q, (snapshot) => {
      const categoriesData = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      setExpenseCategories(sortByLedger(categoriesData));
    });
    return unsubscribe;
  }, [user]);

  return (
    <div className="section-content">
      <div className="page-header">
        <h2>Categories</h2>
        <button className="btn-primary" onClick={() => setShowAddDialog(true)}>
          + Add Category
        </button>
      </div>
      
      <div className="categories-grid">
        
        {/* Income Categories Table */}
        <div className="category-section income-section">
          <div className="category-header">
            <h3>💰 Income</h3>
            <span className="category-count">{incomeCategories.length} categories</span>
          </div>
          
          {incomeCategories.length === 0 ? (
            <p className="empty-state">No income categories yet.</p>
          ) : (
            <table className="category-table">
              <thead>
                <tr>
                  <th>NAME</th>
                  <th>LEDGER</th>
                  <th>GROUP</th>
                  <th className="center">BUDGET</th>
                  <th className="center">ACTIONS</th>
                </tr>
              </thead>
              <tbody>
                {incomeCategories.map((category) => (
                  <tr key={category.id}>
                    <td className="category-name">
                      <strong>{category.name}</strong>
                    </td>
                    <td className="category-ledger">{category.Ledger || '-'}</td>
                    <td className="category-group">{category.group || '-'}</td>
                    <td className="category-budget">
                      <span className={`budget-badge ${category.includeInBudget ? 'yes' : 'no'}`}>
                        {category.includeInBudget ? 'Yes' : 'No'}
                      </span>
                    </td>
                    <td className="category-actions">
                      <button 
                        className="btn-edit" 
                        onClick={() => {
                          setEditingCategory({ ...category, categoryType: 'income' });
                          setShowAddDialog(true);
                        }}
                      >
                        Edit
                      </button>
                      <button className="btn-delete-disabled" disabled>Delete</button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
        
        {/* Expense Categories Table */}
        <div className="category-section expense-section">
          <div className="category-header">
            <h3>💳 Expenses</h3>
            <span className="category-count">{expenseCategories.length} categories</span>
          </div>
          
          {expenseCategories.length === 0 ? (
            <p className="empty-state">No expense categories yet.</p>
          ) : (
            <table className="category-table">
              <thead>
                <tr>
                  <th>NAME</th>
                  <th>LEDGER</th>
                  <th>GROUP</th>
                  <th className="center">BUDGET</th>
                  <th className="center">ACTIONS</th>
                </tr>
              </thead>
              <tbody>
                {expenseCategories.map((category) => (
                  <tr key={category.id}>
                    <td className="category-name">
                      <strong>{category.name}</strong>
                    </td>
                    <td className="category-ledger">{category.Ledger || '-'}</td>
                    <td className="category-group">{category.group || '-'}</td>
                    <td className="category-budget">
                      <span className={`budget-badge ${category.includeInBudget ? 'yes' : 'no'}`}>
                        {category.includeInBudget ? 'Yes' : 'No'}
                      </span>
                    </td>
                    <td className="category-actions">
                      <button 
                        className="btn-edit" 
                        onClick={() => {
                          setEditingCategory({ ...category, categoryType: 'expense' });
                          setShowAddDialog(true);
                        }}
                      >
                        Edit
                      </button>
                      <button className="btn-delete-disabled" disabled>Delete</button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
        
      </div>

      <AddCategoryDialog
        isOpen={showAddDialog}
        onClose={() => {
          setShowAddDialog(false);
          setEditingCategory(null);
        }}
        onSuccess={() => {
          // Categories will auto-reload via onSnapshot
        }}
        editCategory={editingCategory}
      />
    </div>
  );
}

export default Categories;